<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title p-2">
					<div class="row">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-handshake"></i>
								Tour Summary&nbsp;&nbsp;
							</h4>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.filterTours">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="custom-header"
									>
										Filter Summaries
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="row mb-3 d-flex">
											<div class="col-md-3">
												<label for="example-text-input" class="form-label"
													>Start Date</label
												>
												<input
													class="form-control rounded-0"
													type="date"
													value="Artisanal kale"
													id="example-text-input"
												/>
											</div>
											<div class="col-md-3">
												<label for="example-text-input" class="form-label"
													>End Date</label
												>
												<input
													class="form-control rounded-0"
													type="date"
													value="Artisanal kale"
													id="example-text-input"
												/>
											</div>
											<div class="col-md-3">
												<label for="example-text-input" class="form-label"
													>Registered Tour</label
												>
												<input
													class="form-control rounded-0"
													type="text"
													value="Artisanal kale"
													id="example-text-input"
												/>
											</div>
											<div
												class="col-md-3 d-flex justify-content-end align-items-center gap-2"
												style="font-family: HeaderCustomFont"
											>
												<button
													type="submit"
													class="btn btn-info mt-6 rounded-0 text-white"
												>
													<i class="nav-icon fas fa-filter"></i
													>&nbsp;&nbsp;Filter Summaries
												</button>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row col-sm-12 mt-2">
									<div class="table-responsive p-1">
										<v-text-field
											v-model="searchSummaries"
											label="Search Tour Summaries"
											prepend-inner-icon="mdi-magnify"
											flat
											rounded="0"
											variant="outlined"
											density="compact"
											class=""
										></v-text-field>
										<v-data-table
											v-model:items-per-page="summaryPerPage"
											:headers="summaryHeaders"
											:items="summaries"
											:search="searchSummaries"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 text-truncate table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr v-for="(item, index) in items" :key="item.name">
													<td>{{ index + 1 }}</td>
													<td>{{ item.day }}</td>
													<td>{{ item.title }}</td>
													<td>{{ item.destination }}</td>
													<td>{{ item.activity }}</td>
													Accommodation
													<td class="d-none">
														<v-icon large @click="deleteRecord(item)">
															mdi-access-point-remove
														</v-icon>

														<v-icon large @click="editRecord(item)">
															mdi-pencil
														</v-icon>

														<v-icon large @click="displayReport(item)">
															mdi-file-document
														</v-icon>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- </div> -->
				</div>
			</div>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			message: "",
			http_code: "",
			user: [],
			// Users Table Data
			searchSummaries: "",
			summaryPerPage: 5,
			summaries: [],
			summaryHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Status", value: "status", sortable: true },
				{ title: "Agent", value: "agent", sortable: true },
				{ title: "Client", value: "client", sortable: true },
				{ title: "Country", value: "country", sortable: true },
				{ title: "Travel", value: "travel", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				{ title: "Tracking", value: "tracking", sortable: true },
				{ title: "Permit", value: "permit", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
			],

			openPanels: {
				bookingForm: [0],
				filterTours: [0],
			},
			tourItinerary: new Form({
				id: "",
			}),
		};
	},
	computed: {},
	methods: {
		async checkLogin() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (auth == null || user_id == null) {
				this.$router.push("/");
				this.logout();
				this.$swal({
					text: "Session time out",
					icon: "error",
					position: "bottom-end",
					background: "#E74C3C",
					timer: 7500,
				});
			} else {
				let api = this.api + "/check";
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
					if (user_id !== null && auth !== null) {
						this.$router.push("/dash");
					}
				}

				if (query.result == "fail") {
					this.message = query.response.message;
					this.http_code = query.code;
					if (this.http_code == 503) {
						this.$swal({
							text: "Error " + this.http_code + ": " + this.message,
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
						});
					}

					localStorage.clear();
					sessionStorage.clear();
				}
			}
		},
		async authUser() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (user_id !== null && auth !== null) {
				var api = this.api + "/user/" + user_id;
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.user = query.response.data;
					this.user_department = this.user.Department_id;
					localStorage.setItem("user_department", this.user.Department_id);
					localStorage.setItem("user_directorate", this.user.Directorate_id);
					localStorage.setItem(
						"selected_directorate",
						this.user.Directorate_id
					);
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
					this.$swal({
						text: "Error " + this.http_code + ": " + this.message,
						icon: "error",
						position: "bottom-end",
						background: "#E74C3C",
						timer: 7500,
					});
					this.$router.push("/");
				}
			}
		},
	},
	created() {},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>



